<template>
  <div class="photo-container">
    <!-- Logos parte superior -->
    <div class="header-logos">
      <img src="@/assets/logo.png" alt="HP y Real Madrid" />
      <p class="tech-partner">TECHNOLOGY PARTNER</p>
    </div>

    <!-- Recuadro central blanco -->
    <div class="photo-frame"></div>

    <!-- Botón central -->
    <div class="take-photo-btn" @click="irACamara">Tomar foto</div>

    <!-- Textos laterales -->
    <div class="left-text">
      Colócate en el marco<br />
      y saca el jugador<br />
      que llevas dentro
    </div>

    <div class="right-text">
      ¡Me gusta!<br />
      Repetir foto
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    try {
      await this.$store.dispatch('generateTokens');
    } catch (error) {
      alert('Error al generar los tokens. Intente nuevamente.');
    }
  },
  methods: {
    irACamara() {
      this.$router.push('/tomafoto');
    },
  },
};
</script>

<style lang="scss" scoped>
.photo-container {
  background-color: #0095d9;
  width: 100vw;
  height: 100vh;
  font-family: 'FormaDJRDisplay', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
  overflow: hidden;
}

.header-logos {
  position: absolute;
  top: 2vh;
  left: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 180px;
    max-width: 45vw;
  }
  .tech-partner {
    font-size: 0.9rem;
    margin-top: 0.5rem;
    text-align: center;
  }
}

.photo-frame {
  width: 35vw;
  max-width: 340px;
  aspect-ratio: 3/4;
  background-color: white;
  margin-top: 4rem;
}

.take-photo-btn {
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  font-size: 1.5rem;
  margin-top: 2rem;
  padding: 0.5rem 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: white;
    color: #0095d9;
  }
}

.left-text,
.right-text {
  position: absolute;
  bottom: 4vh;
  font-size: 1.2rem;
  width: 30vw;
  text-align: left;
  line-height: 1.3;
}

.left-text {
  left: 2vw;
}

.right-text {
  right: 2vw;
  text-align: right;
}
</style>
